import React from 'react';
import ReactDOM from 'react-dom/client';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import * as Sentry from '@sentry/react';

import 'bootstrap/dist/css/bootstrap.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import reportWebVitals from './reportWebVitals';
import reducers from './state/reducers';
import App from './App';
import './index.css';

const store = createStore(reducers, composeWithDevTools());

Sentry.init({
   dsn: 'https://574e86a022fb694843418adfb6ddd2d5@o380431.ingest.sentry.io/4506715827077120',
   integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
         maskAllText: false,
         blockAllMedia: false
      })
   ],
   tracesSampleRate: 1.0,
   tracePropagationTargets: ['localhost', /^https:\/\/info-cms.konsport.com/],
   replaysSessionSampleRate: 0.1
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <Provider store={store}>
      <React.StrictMode>
         <App />
      </React.StrictMode>
   </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
